<app-header></app-header>
<div class="auth-container flex flex-col lg:flex-row" style="margin-top: -30px;">
    <!-- Left Side (Branding) - Hidden on mobile -->
    <div class="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-wattpad-primary to-wattpad-secondary items-center justify-center p-12">
        <div class="max-w-md text-center text-white">
            <h1 class="text-4xl font-bold mb-8">Add stories & read anywhere, anytime</h1>
            
            <div class="space-y-6 mb-8">
                <div class="flex items-start space-x-4">
                    <div class="bg-white/20 p-2 rounded-full mt-1">
                        <i class="fas fa-bookmark text-lg"></i>
                    </div>
                    <div class="text-left">
                        <h3 class="font-semibold">Save your favorite stories</h3>
                        <p class="text-white/90 text-sm">Continue reading seamlessly across devices</p>
                    </div>
                </div>
                
                <div class="flex items-start space-x-4">
                    <div class="bg-white/20 p-2 rounded-full mt-1">
                        <i class="fas fa-trophy text-lg"></i>
                    </div>
                    <div class="text-left">
                        <h3 class="font-semibold">Write and win prizes</h3>
                        <p class="text-white/90 text-sm">Share your stories, join contests, and get rewarded with exciting prizes</p>
                    </div>
                </div>
                
                <div class="flex items-start space-x-4">
                    <div class="bg-white/20 p-2 rounded-full mt-1">
                        <i class="fas fa-users text-lg"></i>
                    </div>
                    <div class="text-left">
                        <h3 class="font-semibold">Connect with friends & read together</h3>
                        <p class="text-white/90 text-sm">Follow friends, share recommendations, and enjoy stories as a community</p>
                    </div>
                </div>
                
                <div class="flex items-start space-x-4">
                    <div class="bg-white/20 p-2 rounded-full mt-1">
                        <i class="fas fa-pen-fancy text-lg"></i>
                    </div>
                    <div class="text-left">
                        <h3 class="font-semibold">Earn recognition as a writer</h3>
                        <p class="text-white/90 text-sm">Gain followers, likes, and visibility for your work</p>
                    </div>
                </div>
                
                <div class="flex items-start space-x-4">
                    <div class="bg-white/20 p-2 rounded-full mt-1">
                        <i class="fas fa-star text-lg"></i>
                    </div>
                    <div class="text-left">
                        <h3 class="font-semibold">Personalized reading experience</h3>
                        <p class="text-white/90 text-sm">Get story recommendations based on your interests</p>
                    </div>
                </div>
            </div>
            
            <div class="flex justify-center space-x-4 mt-6">
                <div class="bg-white/20 p-3 rounded-full">
                    <i class="fas fa-book-open text-xl"></i>
                </div>
                <div class="bg-white/20 p-3 rounded-full">
                    <i class="fas fa-heart text-xl"></i>
                </div>
                <div class="bg-white/20 p-3 rounded-full">
                    <i class="fas fa-users text-xl"></i>
                </div>
            </div>
        </div>
    </div>

    <!-- Right Side (Form) -->
    <div class="w-full lg:w-1/2 flex items-center justify-center p-6 lg:p-12">
        <div class="w-full max-w-md">

            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-6 lg:p-8">
                <h2 class="text-2xl font-bold mb-6">Log In</h2>
                
                <form [formGroup]="loginForm">
      <div *ngIf="errorMessage" class="alert alert-error mb-4 p-3 rounded-lg bg-red-100 text-red-700">
        {{ errorMessage }}
      </div>
      
      <div *ngIf="successMessage" class="alert alert-success mb-4 p-3 rounded-lg bg-green-100 text-green-700">
        {{ successMessage }}
      </div>
      
      <div class="mb-4">
        <label for="mobile" class="block text-sm font-medium mb-2">Mobile Number</label>
        <input 
          type="tel" 
          name="mobile" 
          formControlName="mobile" 
          class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700" 
          placeholder="Enter your 10-digit mobile number"
          [readonly]="isOtpSent"
        >
        <div *ngIf="loginForm.get('mobile')?.invalid && loginForm.get('mobile')?.touched" class="text-red-500 text-xs mt-1">
          Please enter a valid 10-digit mobile number
        </div>
      </div>
      
      <div *ngIf="isOtpSent" class="mb-4">
        <label for="otp" class="block text-sm font-medium mb-2">OTP</label>
        <input 
          type="text" 
          name="otp" 
          formControlName="otp" 
          class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700" 
          placeholder="Enter 6-digit OTP"
          maxlength="6"
        >
        <div class="flex justify-between mt-2">
          <div *ngIf="loginForm.get('otp')?.invalid && loginForm.get('otp')?.touched" class="text-red-500 text-xs">
            Please enter a valid 6-digit OTP
          </div>
          <div *ngIf="countdown > 0" class="text-sm text-gray-500">
            Resend OTP in {{ countdown }}s
          </div>
          <a *ngIf="countdown <= 0" href="javascript:void(0)" (click)="resendOtp()" class="text-sm text-wattpad-primary hover:underline">
            Resend OTP
          </a>
        </div>
      </div>
      
      <!-- Additional fields for new users -->
      <div *ngIf="showRegistrationFields">
        <div class="mb-4">
          <label for="first_name" class="block text-sm font-medium mb-2">First Name</label>
          <input 
            type="text" 
            name="first_name" 
            formControlName="first_name" 
            class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700" 
            placeholder="Enter your first name"
          >
          <div *ngIf="loginForm.get('first_name')?.invalid && loginForm.get('first_name')?.touched" class="text-red-500 text-xs mt-1">
            First name is required
          </div>
        </div>
        
        <div class="mb-4">
          <label for="last_name" class="block text-sm font-medium mb-2">Last Name</label>
          <input 
            type="text" 
            name="last_name" 
            formControlName="last_name" 
            class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700" 
            placeholder="Enter your last name"
          >
        </div>
        
        <div class="mb-4">
          <label for="email" class="block text-sm font-medium mb-2">Email</label>
          <input 
            type="email" 
            name="email" 
            formControlName="email" 
            class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700" 
            placeholder="Enter your email"
          >
          <div *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" class="text-red-500 text-xs mt-1">
            Please enter a valid email address
          </div>
        </div>
      </div>
      
      <button 
        *ngIf="!isOtpSent"
        type="button" 
        (click)="sendOtp()"
        [disabled]="!loginForm.get('mobile')?.valid"
        class="w-full bg-wattpad-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-[#E5274B] transition-colors mb-4 disabled:bg-gray-400 disabled:cursor-not-allowed"
      >
        Send OTP
      </button>
      
      <button 
*ngIf="isOtpSent"
type="button" 
(click)="showRegistrationFields ? completeRegistration() : verifyOtp()"  
[disabled]="!loginForm.get('otp')?.valid || (showRegistrationFields && !loginForm.get('first_name')?.valid)"
class="w-full bg-wattpad-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-[#E5274B] transition-colors mb-4 disabled:bg-gray-400 disabled:cursor-not-allowed"
>
{{ showRegistrationFields ? 'Complete Registration' : 'Verify OTP & Login' }}
</button>
      
      
    </form>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Bottom Navigation -->
<nav class="bottom-nav fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 lg:hidden">
    <div class="flex justify-around items-center h-full">
        <a href="index4.html" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
            <i class="fas fa-home text-xl"></i>
            <span class="text-xs mt-1">Home</span>
        </a>
        <a href="#" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
            <i class="fas fa-search text-xl"></i>
            <span class="text-xs mt-1">Search</span>
        </a>
        <a href="#" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
            <i class="fas fa-bookmark text-xl"></i>
            <span class="text-xs mt-1">Library</span>
        </a>
        <a href="#" class="text-wattpad-primary flex flex-col items-center">
            <i class="fas fa-user text-xl"></i>
            <span class="text-xs mt-1">Profile</span>
        </a>
    </div>
</nav>